import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import type React from 'react';
import type { SocialAuthProps } from '../SocialAuth.types';

export default (ViewerComponent: React.ComponentType<SocialAuthProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent as any));
